import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import { ButtonSize, ButtonState, ButtonType, IEditModalData, ILanguage } from '../../../assets/types/dtoTypes';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {LanguageDataService} from "../../shared/services/language-data.service";
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf, NgSwitch, NgSwitchCase, NgSwitchDefault, TitleCasePipe} from "@angular/common";
import {AppInputAreaComponent} from "../../shared/text-areas/app-input-area.component";
import {ButtonComponent} from "../../shared/button/button.component";
import {MatChip, MatChipSet, MatChipsModule} from "@angular/material/chips";
import {MatIcon} from "@angular/material/icon";
import {DropdownComponent} from "../../shared/countries-dropdown/dropdown.component";

@Component({
  selector: 'app-edit-modal',
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss'],
  imports: [
    TranslateModule,
    TitleCasePipe,
    AppInputAreaComponent,
    NgSwitch,
    MatDialogTitle,
    NgSwitchCase,
    ReactiveFormsModule,
    NgForOf,
    ButtonComponent,
    NgSwitchDefault,
    MatChip,
    MatChipSet,
    MatChipsModule,
    MatIcon,
    DropdownComponent,
    FormsModule,
  ],
  standalone: true
})
export class EditModalComponent implements OnInit {
  private dataService = inject(LanguageDataService);
  private fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<EditModalComponent>>(MatDialogRef);
  data = inject<IEditModalData>(MAT_DIALOG_DATA);

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  isMobile: boolean = false;

  dataToEdit: string;

  editedValue: string = '';

  selectedLanguages: string[] = [];

  form!: FormGroup;

  filteredLanguages!: Observable<ILanguage[]>;

  languages: ILanguage[] = [];

  languageCtrl = new FormControl();

  constructor() {
    const data = this.data;

    this.dataToEdit = data.dataToEdit;
    this.setInitialValue();

    this.form = this.fb.group( {
      languages: new FormControl( this.selectedLanguages, [ Validators.required ] ),
      skills: [ '', [ Validators.required ] ],
      experience: [ '', [ Validators.required ] ],
    } );


    this.dataService.getLanguages().subscribe( ( returnData ) => {
      this.languages = returnData.languages;
      this.filteredLanguages = this.languageCtrl.valueChanges.pipe(
        startWith( '' ),
        map( value => typeof value === 'string' ? this._filter( value ) : this.languages.slice() ),
      );
    } );
  }

  private _filter( value: string ): ILanguage[] {
    const filterValue = value.toLowerCase();
    return this.languages.filter( language => language.name.toLowerCase().includes( filterValue ) );
  }

  setInitialValue() {
    if ( this.dataToEdit === 'motivation' ) {
      this.editedValue = this.data.motivation || '';
    } else if ( this.dataToEdit === 'languages' ) {
      this.selectedLanguages = Array.isArray( this.data.languages ) ? [ ...this.data.languages ] : [];
    } else if ( this.dataToEdit === 'certificates' ) {
      this.editedValue = this.data.certificates?.join( ', ' ) || '';
    }
  }

  getFlagSrc(languageName: string): string {
    const lang = this.languages?.find(l => l.name === languageName);
    const code = lang?.code ?? 'default';
    return `assets/icons/flags/square/${code.toLowerCase()}.svg`;
  }


  cancel() {
    this.dialogRef.close();
  }

  sendText( event: string ) {
    this.editedValue = event;
  }

  removeLanguage( language: string ): void {
    const index = this.selectedLanguages.indexOf( language );
    if ( index >= 0 ) {
      this.selectedLanguages.splice( index, 1 );
      this.languageCtrl.setValue( this.selectedLanguages );
    }
  }

  save() {
    if ( this.dataToEdit === 'languages' ) {
      this.dialogRef.close( this.selectedLanguages );
    } else if ( this.dataToEdit === 'motivation' ) {
      this.dialogRef.close( this.editedValue );
    }
  }


  ngOnInit() {
    this.languageCtrl.setValue(this.selectedLanguages ?? []);

    this.languageCtrl.valueChanges.subscribe(val => {
      this.selectedLanguages = Array.isArray(val) ? val : [];
    });
  }



}



